import _JSXStyle from "styled-jsx/style";
import { spacers } from '@dhis2/ui-constants';
import { IconCross24 } from '@dhis2/ui-icons';
import PropTypes from 'prop-types';
import React from 'react';

const Dismiss = _ref => {
  let {
    onClick,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1892313381", [spacers.dp16]]])
  }, /*#__PURE__*/React.createElement(IconCross24, null), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1892313381",
    dynamic: [spacers.dp16]
  }, ["div.__jsx-style-dynamic-selector{margin-inline-start:".concat(spacers.dp16, ";min-height:32px;min-width:32px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;border-radius:5px;}"), "div.__jsx-style-dynamic-selector:hover{cursor:pointer;background:rgba(0,0,0,0.15);}", "div.__jsx-style-dynamic-selector:active{background:rgba(0,0,0,0.25);}", "div.__jsx-style-dynamic-selector svg{width:18px;height:18px;}"]));
};

Dismiss.propTypes = {
  dataTest: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
export { Dismiss };